import { convertFromESTToLocal } from '@/utils/date/temporary';

import type { LADClaimPrintFormResponse } from './api';

export const normalizeLADClaimPrintForm = (data: LADClaimPrintFormResponse) => {
  if (!data) {
    return [];
  }
  return data.map((printForm) => ({
    ...printForm,
    dateFiled: convertFromESTToLocal(printForm?.dateFiled),
    dateShipped: convertFromESTToLocal(printForm?.dateShipped),
  }));
};
